export function dashboardUrl(path: string = '') {
  return `https://altertable.ai/dashboard${path}`;
}
